const backgroundImage = require("./background-image");

let _this = (module.exports = {
	// Set the dom elements
	dom: {},

	// Set variables
	vars: {
		flag: {},
	},

	/**
	 * Init functions
	 */
	init: function () {
		jQuery(function ($) {
			$(document).on(
				'click',
				'.shop-loop-cart .add_to_cart_button',
				function () {
					const $form = $(this).closest('form');
					const qty = $form.find('input.qty').val() || 1;

					$(this).attr('data-quantity', qty);

					changeImagesSize();
				},
			);
			const numberInputPlus = $('.number-input--plus');
			const numberInputMinus = $('.number-input--minus');

			numberInputMinus.on('click', function () {
				const parentNumberInput = $(this).parent('.number-input');
				const numberInput = parentNumberInput.find('[type="number"]');
				const minimum = numberInput.attr('min')
					? parseFloat(numberInput.attr('min'))
					: 0;
				const step = numberInput.attr('step')
					? parseFloat(numberInput.attr('step'))
					: 1;
				const newValue = parseFloat(numberInput.val()) - step;
				numberInput.val(minimum <= newValue ? newValue : minimum);
				numberInput.trigger('change');
			});
			numberInputPlus.on('click', function () {
				const parentNumberInput = $(this).parent('.number-input');
				const numberInput = parentNumberInput.find('[type="number"]');
				const step = numberInput.attr('step')
					? parseFloat(numberInput.attr('step'))
					: 1;
				const maximum = numberInput.attr('max')
					? parseFloat(numberInput.attr('max'))
					: null;
				const newValue = parseFloat(numberInput.val()) + step;
				numberInput.val(maximum && maximum <= newValue ? maximum : newValue);
				numberInput.trigger('change');
			});
		});
	},
});
